import { ActionTypes } from '../../constants/ActionTypes';
import { IItem } from '../../interfaces';
import {
  IGetLetterNoteParams,
  INewLetterNote,
  INoteList,
} from '../../interfaces/Note';

export const onGetLetterLetterNote = (params: IGetLetterNoteParams) => {
  return {
    type: ActionTypes.GET_LETTER_NOTE,
    payload: params,
  };
};

export const fetchLetterLetterNoteSuccess = (letterNotes: INoteList[]) => {
  return {
    type: ActionTypes.FETCH_LETTER_NOTE_SUCCESS,
    payload: letterNotes,
  };
};

export const onAddLetterNote = (params: INewLetterNote) => {
  return {
    type: ActionTypes.ADD_LETTER_NOTE,
    payload: params,
  };
};

export const onAddLetterNoteSuccess = () => {
  return {
    type: ActionTypes.ADD_LETTER_NOTE_SUCCESS,
  };
};
